/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  MiddlewareError,
  SetStoreProfileVisibilityRequest,
  StoreProfileDetails,
  StoreProfiles,
} from '../models/index';
import {
    MiddlewareErrorFromJSON,
    MiddlewareErrorToJSON,
    SetStoreProfileVisibilityRequestFromJSON,
    SetStoreProfileVisibilityRequestToJSON,
    StoreProfileDetailsFromJSON,
    StoreProfileDetailsToJSON,
    StoreProfilesFromJSON,
    StoreProfilesToJSON,
} from '../models/index';

export interface DeleteStoreProfileOfCurrentRetailerRequest {
    uuid: string;
}

export interface GetStoreProfileDetailsOfCurrentRetailerRequest {
    uuid: string;
}

export interface SetVisibilityOfStoreProfileOfCurrentRetailerRequest {
    uuid: string;
    setStoreProfileVisibilityRequest: SetStoreProfileVisibilityRequest;
}

/**
 * 
 */
export class StoreProfileResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for deleteStoreProfileOfCurrentRetailer without sending the request
     */
    async deleteStoreProfileOfCurrentRetailerRequestOpts(requestParameters: DeleteStoreProfileOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteStoreProfileOfCurrentRetailer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/store-profile/{uuid}`;
        urlPath = urlPath.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteStoreProfileOfCurrentRetailerRaw(requestParameters: DeleteStoreProfileOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteStoreProfileOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteStoreProfileOfCurrentRetailer(requestParameters: DeleteStoreProfileOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteStoreProfileOfCurrentRetailerRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getStoreProfileDetailsOfCurrentRetailer without sending the request
     */
    async getStoreProfileDetailsOfCurrentRetailerRequestOpts(requestParameters: GetStoreProfileDetailsOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getStoreProfileDetailsOfCurrentRetailer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/store-profile/{uuid}`;
        urlPath = urlPath.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getStoreProfileDetailsOfCurrentRetailerRaw(requestParameters: GetStoreProfileDetailsOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreProfileDetails>> {
        const requestOptions = await this.getStoreProfileDetailsOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreProfileDetailsFromJSON(jsonValue));
    }

    /**
     */
    async getStoreProfileDetailsOfCurrentRetailer(requestParameters: GetStoreProfileDetailsOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreProfileDetails> {
        const response = await this.getStoreProfileDetailsOfCurrentRetailerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getStoreProfilesOfCurrentRetailer without sending the request
     */
    async getStoreProfilesOfCurrentRetailerRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/store-profile`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getStoreProfilesOfCurrentRetailerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreProfiles>> {
        const requestOptions = await this.getStoreProfilesOfCurrentRetailerRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreProfilesFromJSON(jsonValue));
    }

    /**
     */
    async getStoreProfilesOfCurrentRetailer(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreProfiles> {
        const response = await this.getStoreProfilesOfCurrentRetailerRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setVisibilityOfStoreProfileOfCurrentRetailer without sending the request
     */
    async setVisibilityOfStoreProfileOfCurrentRetailerRequestOpts(requestParameters: SetVisibilityOfStoreProfileOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling setVisibilityOfStoreProfileOfCurrentRetailer().'
            );
        }

        if (requestParameters['setStoreProfileVisibilityRequest'] == null) {
            throw new runtime.RequiredError(
                'setStoreProfileVisibilityRequest',
                'Required parameter "setStoreProfileVisibilityRequest" was null or undefined when calling setVisibilityOfStoreProfileOfCurrentRetailer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/ui/store-profile/{uuid}/visibility`;
        urlPath = urlPath.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetStoreProfileVisibilityRequestToJSON(requestParameters['setStoreProfileVisibilityRequest']),
        };
    }

    /**
     */
    async setVisibilityOfStoreProfileOfCurrentRetailerRaw(requestParameters: SetVisibilityOfStoreProfileOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.setVisibilityOfStoreProfileOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async setVisibilityOfStoreProfileOfCurrentRetailer(requestParameters: SetVisibilityOfStoreProfileOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setVisibilityOfStoreProfileOfCurrentRetailerRaw(requestParameters, initOverrides);
    }

}
